import { render, staticRenderFns } from "./tradeOrderEditPricePart.vue?vue&type=template&id=4ca44480&scoped=true&"
import script from "./tradeOrderEditPricePart.vue?vue&type=script&lang=js&"
export * from "./tradeOrderEditPricePart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca44480",
  null
  
)

export default component.exports